const moduleName = "wms/businessRuleShelves/";
export const id = {
    id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_SHELVES",
    name: "上架规则",
    type: "menu",
    apiName: "getShelvesList",
    url: `${moduleName}list`
};

export const children = {
    // GET_LIST: {
    //     id: 'WAREHOUSE_MANAGEMENT_BUSINESS_RULES_SHELVES_GET_LIST',
    //     apiName: 'getCarTypes',
    //     method: 'POST',
    //     name: '获取列表',
    //     type: 'view',
    //     url: `${moduleName}carType/getCarTypes`
    // },
    ADD_DATA: {
        id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_SHELVES_ADD_DATA",
        apiName: "addShelves",
        method: "POST",
        name: "新建",
        type: "view",
        url: `${moduleName}save`
    },
    DEL_DATA: {
        id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_SHELVES_CODE",
        apiName: "delShelves",
        method: "POST",
        name: "删除",
        type: "view",
        url: `${moduleName}delete`
    },
    EDIT_DATA: {
        id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_SHELVES_EDIT_DATA",
        apiName: "editShelves",
        method: "POST",
        name: "编辑",
        type: "view",
        url: `${moduleName}save`
    },
    LOOK_MORE: {
        id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_SHELVES_LOOK_MORE",
        name: "查看",
        type: "view"
    }
};
